<template>
  <div class="giphy">
    <img src="/static/img/loader.gif" ref="imgContainer">
  </div>
</template>


<script>
import GphApiClient from "giphy-js-sdk-core";

const giffyClient = GphApiClient("0iN99ST5SvmZThQRu94KxSf39xSoUKyD");

export default {
  props: ["giphy"],
  name: "ContentGiphy",
  data() {
    return {
      giphySrc: []
    };
  },
  created() {
    this.getGiffy(this.giphy);
  },
  methods: {
    getGiffy(ids) {
      const instance = this;
      giffyClient
        .gifsByIDs({ ids })
        .then(response => {
          console.log(response);
          response.data.forEach(item =>{
            const url = item.images.original.url || item.images.original.gif_url;
            this.giphySrc.push(url)
          });
          const rnd = Math.floor(Math.random() * this.giphySrc.length);
          this.$refs.imgContainer.src = this.giphySrc[rnd];
        })
        .catch(err => {
          throw err;
        });
    }
  },
  mounted() {
    this.$emit("giphyInit");
  }
};
</script>

<style lang="scss" scoped>
.giphy {
  display: flex;
  justify-content: flex-end;

  img {
    margin: 1em 0;
    height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ContentGiphy.vue